export abstract class Media {
  constructor() {}

  abstract get thumbnail(): string;
  abstract copy(): Media;
  abstract equals(media: Media): boolean;

  get alt(): string | undefined {
    return undefined;
  }
}
